import { SM } from '../assets/data/enum/storeModel.enum';
import { SAASBRANDNAME } from '../assets/data/enum/saasBrandName.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'tafedigiag',
    textName: 'TAFE Terra Horizon',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=tafedigiag',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=tafedigiag',
    enableLoginForm: false,
    enableForgotPassword: false,
    enableRegistration: false,
    activeSocial: [SAASBRANDNAME.TAFEDIGIAG],
    versionPublicPage: 'v60',
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    welcomeUserCheck: false,
    store: false,
  },
  apiBaseUrl: 'https://api-tafedigiag.xfarm.ag/',
  SSOfrontAppCallback: 'https://horizon.tafeterra.com/#/oauthCheck?token=',
  launchDarklyKey: '67604ad17d39af0965e938ff',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/tafedigiag/',
  palette: {
    '--p-xFarm-xColor-50': '#ffe3d2',
    '--p-xFarm-xColor-100': '#ffc6a5',
    '--p-xFarm-xColor-200': '#ffaa7a',
    '--p-xFarm-xColor-300': '#fc8d4f',
    '--p-xFarm-xColor-400': '#f37020',
    '--p-xFarm-xColor-500': '#d8651f',
    '--p-xFarm-xColor-600': '#be591d',
    '--p-xFarm-xColor-700': '#a54e1c',
    '--p-xFarm-xColor-800': '#8c441a',
    '--p-xFarm-xColor-900': '#743918',
    '--p-xFarm-xColor-950': '#5d2f15',
  },
  primary: '#F37020',
  primaryOpacity: '#F37020',
  primaryOpacity15: '#F3702026',
  secondary: '#bcbec0',
  textLoginVersion: '#FFFFFF',
  btnSuccess: '#F37020',
  backgroundSplashScreen: '#F37020',
  spinnerSplashScreen: '#000000',
  navBarColor: '#F37020',
  colorSidebarHeader: '#bcbec0',
};
